import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AdminNav from "./AdminNav";
import DashboardHeader from "./DashboardHeader";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import SimpleCard from "@gull/components/cards/SimpleCard";
import PersonalStatementTab from "./PersonalStatementEditor";
import swal from "sweetalert2";
const ViewApplication = () => {
    const { id } = useParams();
    const [education, setEducation] = useState([]);
    const [employment, setEmployment] = useState([]);
    const [resume, setResume] = useState([]);
    const [personalstatement, setPersonalStatement] = useState([]);
    const [personalStatementId, setPersonalStatementId] = useState("");
    const [referenceletter, setReferenceLetter] = useState([]);
    const [referenceletterdata, setReferenceLetterData] = useState([]);
    const [otherevaluations, setOtherEvaluations] = useState([]);
    const [score, setScore] = useState([]);

    const [fields, setFields] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [evaluationId, setEvaluationId] = useState("");
    const campaigin_id = localStorage.getItem('campaigin_id'); // Assuming the token is stored in localStorage

    
    const [data, setData] = useState({
        creativity: 0,
        expression: 0,
        past_ambition: 0,
        future_ambition: 0,
        relevance: 0,
        program_fit: 0,
        totalScore: 0,
        remarks: "",
        next_stage: undefined, // No selection yet; will be true (recommended), false (rejected), or null (waitlist)

      });

      // Campaign 7+ uses new field labels and includes program_fit
      const isNewCampaign = Number(campaigin_id) >= 7;
    const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
    const userdata = JSON.parse(localStorage.getItem("auth_user_info"));
    const loggedInUserId= userdata.id
    const username= userdata.username

    console.log("loggedInUserId",loggedInUserId)


    console.log("token",token)
    // const auth = JSON.parse(localStorage.getItem("auth_user_info"));

    // const applicantID = auth ? auth.id : null;

     // Handle input changes and update state


     useEffect(() => {
      const fetchEvaluations = async () => {
          try {
              const response = await fetch(
                  `${process.env.REACT_APP_BASE_URL_strapi}/evaluations?populate=application&populate=users_permissions_user&filters[application][id][$eq]=${id}`,
                  {
                      method: 'GET',
                      headers: {
                          'Authorization': `Bearer ${token}`, // JWT token of the logged-in user
                      },
                  }
              );
  
              const data = await response.json();
              console.log('All evaluations for the application:', data);
  
              if (data?.data?.length) {
                  // Filter out the evaluation with userId 53
                  const filteredEvaluations = data.data.filter(
                      (evaluation) => evaluation.attributes.users_permissions_user.data.id !== loggedInUserId
                  );
  
                  // Update state with the filtered evaluations
                  setOtherEvaluations(
                      filteredEvaluations.map((evaluation) => ({
                          ...evaluation.attributes,
                          totalScore:
                              evaluation.attributes.creativity +
                              evaluation.attributes.expression +
                              evaluation.attributes.past_ambition +
                              evaluation.attributes.future_ambition +
                              evaluation.attributes.relevance +
                              (isNewCampaign ? (evaluation.attributes.program_fit || 0) : 0),
                      }))
                  );
                  console.log("evaluations",otherevaluations)
              } else {
                  console.log('No evaluations found for this application.');
              }
          } catch (error) {
              console.error('Error fetching evaluations:', error);
          }
      };
  
      fetchEvaluations();
  }, [id, token]);

     useEffect(() => {
        const fetchData = async () => {
            fetch(`${process.env.REACT_APP_BASE_URL_strapi}/users/me?populate[evaluations][filters][application][id][$eq]=${id}`, { 
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}` // JWT token of the logged-in user
                }
              })
                .then(response => response.json())
                .then(evaluation => {
                  console.log('User with filtered evaluations:', evaluation);
              
                  const evaluations = evaluation.evaluations[0]; // Extract the filtered evaluations from the populated response
                  if (evaluations) {
                    evaluations.totalScore =
                    evaluations.creativity +
                    evaluations.expression +
                    evaluations.past_ambition +
                    evaluations.future_ambition +
                    evaluations.relevance +
                    (isNewCampaign ? (evaluations.program_fit || 0) : 0);
                    setData(evaluations)
                    setEvaluationId(evaluations.id); // Store the evaluation ID in the state for future updates
                    console.log("filtered evaluation for the user related to the application:", evaluations);
                    // Assuming evaluations are returned and are related to applications
                 
                  } else {
                    console.log('No evaluations related to the specified application found for the user');
                  }
                })
                .catch(error => {
                  console.error('Error fetching user and filtered evaluations:', error);
                });
              
        };
            // Fetch the latest campaign first
    
    
        fetchData();
      }, []);




      const handleInputChange = (event, nextStageValue) => {
        const { name, type } = event.target;

        if (type === "radio") {
          setData((prevData) => ({
            ...prevData,
            [name]: nextStageValue === "recommended" ? true : nextStageValue === "rejected" ? false : null,
          }));
        } else {
          // Handle other input types (e.g., number inputs)
          const { value } = event.target;
          const parsedValue = value === "" ? 0 : parseInt(value, 10);
      
          if (parsedValue > 5) {
            swal.fire({
              title: "Invalid Score",
              text: "Score cannot be more than 5",
              icon: "warning",
              confirmButtonColor: "#0891b2",
              confirmButtonText: "OK",
            });
            return;
          }
      
          setData((prevData) => {
            const newData = {
              ...prevData,
              [name]: isNaN(parsedValue) ? 0 : parsedValue,
            };

            const totalScore =
              newData.creativity +
              newData.expression +
              newData.past_ambition +
              newData.future_ambition +
              newData.relevance +
              (isNewCampaign ? (newData.program_fit || 0) : 0);

            return {
              ...newData,
              totalScore, // Update the total score
            };
          });
        }
      };
      
      
const handleButtonClick1 = async (event) => {
    if (!id || !token) {
      alert("Application ID or Token missing!");
      return;
    }
  
    try {
      // Cross-tab safeguard: resolve existing evaluation from server for this user+application.
      let resolvedEvaluationId = evaluationId;
      if (!resolvedEvaluationId) {
        const existingEvalResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL_strapi}/evaluations?filters[application][id][$eq]=${id}&filters[users_permissions_user][id][$eq]=${loggedInUserId}&pagination[pageSize]=1`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (existingEvalResponse.ok) {
          const existingEvalData = await existingEvalResponse.json();
          resolvedEvaluationId = existingEvalData?.data?.[0]?.id || "";
          if (resolvedEvaluationId) {
            setEvaluationId(resolvedEvaluationId);
          }
        }
      }

      // Check if an evaluation ID exists (from the useEffect)
      console.log("Data to be saved:", evaluationId); // Log the data being sent to the API
      if (resolvedEvaluationId) {
        console.log("1111111", resolvedEvaluationId);
        // If evaluation ID exists, update the existing evaluation
        const updateResponse = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/evaluations/${resolvedEvaluationId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Pass the token for authentication
          },
          body: JSON.stringify({
            data: {
              creativity: data.creativity,
              expression: data.expression,
              past_ambition: data.past_ambition,
              future_ambition: data.future_ambition,
              relevance: data.relevance,
              ...(isNewCampaign && { program_fit: data.program_fit }),
              totalScore: data.totalScore,
              next_stage: data.next_stage,
              remarks:data.remarks,
              application: id, // Send the application ID
            },
          }),
        });

        if (updateResponse.ok) {
            const responseData = await updateResponse.json();
            console.log("Evaluation updated successfully:", responseData.data.id);

            // If waitlist is selected, keep application status as "new" (listing color changes via evaluation next_stage)
            if (data.next_stage === null) {
                let outgoingData = {
                    status: 'new'
                }
                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
                        method: 'PUT',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ data: outgoingData })
                    });
                    if (!response.ok) {
                        throw new Error('Failed to submit form');
                    }
                    const data = await response.json();
                    console.log(data);
                } catch (error) {
                    console.error('Error:', error);
                }
                swal.fire({
                    title: "Waitlisted",
                    text: "Evaluation updated successfully! Application has been waitlisted.",
                    icon: "info",
                    confirmButtonColor: "#0891b2",
                    confirmButtonText: "OK",
                }).then(() => {
                    window.history.back();
                });
            } else {
                // For recommended/rejected, use majority vote logic

                // After creating the evaluation, fetch all evaluations related to the application
                const fetchEvaluationsResponse = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/evaluations?filters[application][id][$eq]=${id}&populate=*`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`, // Pass the token for authentication
                },
                });

                if (fetchEvaluationsResponse.ok) {
                const evaluationsData = await fetchEvaluationsResponse.json();
                console.log("All evaluations fetched successfully:", evaluationsData);

                // Map through the evaluations and count the number of recommended/rejected
                const result = evaluationsData.data.reduce(
                    (acc, val) => {
                    if (val.attributes.next_stage == true) {
                        acc.trueCount++;
                    } else if(val.attributes.next_stage == false) {
                        acc.falseCount++;
                    }
                    return acc;
                    },
                    { trueCount: 0, falseCount: 0 }
                );

                // Check the conditions and return the appropriate value
                let finalDecision = "none"; // Default value
                if (result.trueCount >= 2) {
                    let  outgoingData = {
                        status:'approved'
                    }
                     try {
                        const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
                          method: 'PUT',
                          headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json', // Ensure content-type is set to JSON
                          },
                          body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
                        });

                        if (!response.ok) {
                          throw new Error('Failed to submit form');
                        }

                        const data = await response.json();
                        console.log(data);
                      } catch (error) {
                        console.error('Error:', error);
                      }



                    finalDecision = "yes";
                } else if (result.falseCount >= 2) {
                  let  outgoingData = {
                    status:'rejected'
                  }
                    try {
                        const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
                          method: 'PUT',
                          headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json', // Ensure content-type is set to JSON
                          },
                          body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
                        });

                        if (!response.ok) {
                          throw new Error('Failed to submit form');
                        }

                        const data = await response.json();
                        console.log(data);
                      } catch (error) {
                        console.error('Error:', error);
                      }

                    finalDecision = "no";
                }

                const decisionTitle = finalDecision === "yes" ? "Accepted" : finalDecision === "no" ? "Rejected" : "Evaluation Updated";
                const decisionText = finalDecision === "yes"
                    ? "Application has been accepted successfully!"
                    : finalDecision === "no"
                    ? "Application has been rejected successfully!"
                    : "Evaluation updated successfully!";
                const decisionIcon = finalDecision === "yes" ? "success" : finalDecision === "no" ? "error" : "info";

                swal.fire({
                    title: decisionTitle,
                    text: decisionText,
                    icon: decisionIcon,
                    confirmButtonColor: "#0891b2",
                    confirmButtonText: "OK",
                }).then(() => {
                    window.history.back();
                });

                console.log("Final decision:", finalDecision);
              // Handle the evaluations data (for example, update the state or display the data)
              // You can set the data in a state or manipulate it as needed

            } else {
              console.error("Failed to fetch evaluations:", fetchEvaluationsResponse);
              alert("Failed to fetch evaluations. Please try again.");
            }
        }
        } else {
            console.error("Failed to update evaluation:", updateResponse);
            alert("Failed to update evaluation. Please try again.");
        }
      } else {
                console.log("222222", resolvedEvaluationId);

        // If no evaluation ID, create a new evaluation
        const createResponse = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/evaluations`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Pass the token for authentication
          },
          body: JSON.stringify({
            data: {
              creativity: data.creativity,
              expression: data.expression,
              past_ambition: data.past_ambition,
              future_ambition: data.future_ambition,
              relevance: data.relevance,
              ...(isNewCampaign && { program_fit: data.program_fit }),
              totalScore: data.totalScore,
              next_stage: data.next_stage,
              remarks:data.remarks,
              application: id, // Send the application ID
            },
          }),
        });

        if (createResponse.ok) {
            const responseData = await createResponse.json();
            console.log("Evaluation created successfully:", responseData);
             setEvaluationId(responseData.data.id); // Update the evaluation ID in case it was changed

            // If waitlist is selected, keep application status as "new" (listing color changes via evaluation next_stage)
            if (data.next_stage === null) {
                let outgoingData = {
                    status: 'new'
                }
                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
                        method: 'PUT',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ data: outgoingData })
                    });
                    if (!response.ok) {
                        throw new Error('Failed to submit form');
                    }
                    const data = await response.json();
                    console.log(data);
                } catch (error) {
                    console.error('Error:', error);
                }
                swal.fire({
                    title: "Waitlisted",
                    text: "Evaluation created successfully! Application has been waitlisted.",
                    icon: "info",
                    confirmButtonColor: "#0891b2",
                    confirmButtonText: "OK",
                }).then(() => {
                    window.history.back();
                });
            } else {
                // For recommended/rejected, use majority vote logic

                // After creating the evaluation, fetch all evaluations related to the application
                const fetchEvaluationsResponse = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/evaluations?filters[application][id][$eq]=${id}&populate=*`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`, // Pass the token for authentication
                },
                });

                if (fetchEvaluationsResponse.ok) {

                const evaluationsData = await fetchEvaluationsResponse.json();
                console.log("All evaluations fetched successfully:", evaluationsData);

                // Handle the evaluations data (for example, update the state or display the data)
                // You can set the data in a state or manipulate it as needed

                // Map through the evaluations and count the number of recommended/rejected
                const result = evaluationsData.data.reduce(
                    (acc, val) => {
                    if (val.attributes.next_stage == true) {
                        acc.trueCount++;
                    } else if(val.attributes.next_stage == false) {
                        acc.falseCount++;
                    }
                    return acc;
                    },
                    { trueCount: 0, falseCount: 0 }
                );

                // Check the conditions and return the appropriate value
                let finalDecision = "none"; // Default value
                if (result.trueCount >= 2) {
                    let  outgoingData = {
                        status:'approved'
                    }
                     try {
                        const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
                          method: 'PUT',
                          headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json', // Ensure content-type is set to JSON
                          },
                          body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
                        });

                        if (!response.ok) {
                          throw new Error('Failed to submit form');
                        }

                        const data = await response.json();
                        console.log(data);
                      } catch (error) {
                        console.error('Error:', error);
                      }



                    finalDecision = "yes";
                } else if (result.falseCount >= 2) {
                  let  outgoingData = {
                    status:'rejected'
                  }
                    try {
                        const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
                          method: 'PUT',
                          headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json', // Ensure content-type is set to JSON
                          },
                          body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
                        });

                        if (!response.ok) {
                          throw new Error('Failed to submit form');
                        }

                        const data = await response.json();
                        console.log(data);
                      } catch (error) {
                        console.error('Error:', error);
                      }

                    finalDecision = "no";
                }

                const decisionTitle = finalDecision === "yes" ? "Accepted" : finalDecision === "no" ? "Rejected" : "Evaluation Created";
                const decisionText = finalDecision === "yes"
                    ? "Application has been accepted successfully!"
                    : finalDecision === "no"
                    ? "Application has been rejected successfully!"
                    : "Evaluation created successfully!";
                const decisionIcon = finalDecision === "yes" ? "success" : finalDecision === "no" ? "error" : "info";

                swal.fire({
                    title: decisionTitle,
                    text: decisionText,
                    icon: decisionIcon,
                    confirmButtonColor: "#0891b2",
                    confirmButtonText: "OK",
                }).then(() => {
                    window.history.back();
                });

            console.log("Final decision:", finalDecision);
          // Handle the evaluations data (for example, update the state or display the data)
          // You can set the data in a state or manipulate it as needed
            
      
            } else {
              console.error("Failed to fetch evaluations:", fetchEvaluationsResponse);
              alert("Failed to fetch evaluations. Please try again.");
            }
          }
          } else {
            console.error("Failed to create evaluation:", createResponse);
            alert("Failed to create evaluation. Please try again.");
          }
      }
    } catch (error) {
      console.error("Error saving evaluation:", error);
      alert("An error occurred while saving the evaluation.");
    }
  };
  
  
    const fetchData = async () => {
        try {
       
            setLoading(false);
            const response1 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}?populate[academic_detailss]=*&populate[personal_statement]=*&populate[privacy_policy_statement]=*&populate[professional_detailss]=*&populate[reference_letter][populate][reference_letter]=*&populate[resume][populate][resume]=*&populate[aptitude_test_response]=*
            `, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Your JWT token
                    'Content-Type': 'application/json'
                }
            });
            const data1 = await response1.json();
            setResume({url:data1?.data?.attributes?.resume?.data?.attributes?.resume?.data?.attributes?.url})
            
         console.log("data1?.data?.attributes?.personal_statement",data1?.data?.attributes?.personal_statement?.data)
             setPersonalStatementId(data1?.data?.attributes?.personal_statement?.data?.id)
              setPersonalStatement(data1?.data?.attributes?.personal_statement?.data?.attributes)
              setFields(data1?.data?.attributes);
              setEducation(data1?.data?.attributes?.academic_detailss?.data);
              setReferenceLetter({url:data1?.data?.attributes?.reference_letter?.data?.attributes?.reference_letter?.data?.attributes?.url})
              setReferenceLetterData(data1?.data?.attributes?.reference_letter?.data?.attributes)
              setEmployment(data1?.data?.attributes?.professional_detailss?.data);
   




              const correctAnswers = {
                quantitative_reasoning: {
                  q1: "None of the above",
                  q2: "C",
                  q3: "A",
                  q4: "B",
                  q5: "C"
                },
                verbal_reasoning: {
                  q1: "They welcomed it as a revolutionary technology.",
                  q2: "Through dreams, myths, and cultural symbols.",
                  q3: "It is filled with chaotic energy yet ultimately lacks meaning.",
                  q4: "Long-term capacity payment obligations on the national exchequer.",
                  q5: "They focus on numerical details rather than personal qualities."
                },
                energy_climate_trivia: {
                  q1: "More than 40%",
                  q2: "2026",
                  q3: "640 MW",
                  q4: "Both A&B",
                  q5: "Rachel Carson’s book on the growing use of pesticides"
                }
              };
              
              const calculateScores = (userAnswers) => {
                let scores = {
                  quantitative_reasoning: 0,
                  verbal_reasoning: 0,
                  energy_climate_trivia: 0,
                  total: 0
                };
              
                // Iterate over each section
                for (let section in correctAnswers) {
                  for (let question in correctAnswers[section]) {
                    if (userAnswers[section][question] === correctAnswers[section][question]) {
                      scores[section] += 1; // Increase score for correct answer
                    }
                  }
                  scores.total += scores[section]; // Sum total score
                }
              
                return scores;
              };
              
            
              // Calculate scores
              const scores = calculateScores(data1?.data?.attributes.aptitude_test_response.data.attributes.answers);
              setScore(scores)
              console.log("scores",scores);

              


              
        setTimeout(() => {
            console.log("fields",fields);
            console.log("education",education);
            console.log("resume",resume);

            
        }, 4000);
        } catch (error) {
            console.error('Error fetching personal information data:', error);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchData();
    }, []);

    const handleButtonClick = async (event) => {
        const eventName = event.target.innerText.toLowerCase();

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/applicant/score`, {
            method: 'PUT',
            headers: {
                'Accept': '*/*',
                'Event': eventName,
                'SessionKey': '123',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                applicantId: parseInt(id),
                graceScore: parseInt(fields.graceScore),
                score: parseInt(fields.score)
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        // console.log(data);
        fetchData();
    }




    // Email and contact
    let emails = fields && fields.email ? fields.email.split(', ') : ['N/A'];
    let contacts = fields && fields.contact ? fields.contact.split(', ') : ['N/A', 'N/A', 'N/A'];

    // Remove 'L:' from the landline number
    if (contacts[2]) {
        contacts[2] = contacts[2].replace('L:', '');
    }
    // Text Formatting
    function formatText(text) {
        let lines = text.split('\n');
        let formattedText = lines.map(line => `<p>${line}</p>`).join('');
        return formattedText;
    }

    let coverLettertext = fields && fields.coverLetter ? formatText(fields.coverLetter) : 'N/A';
    let formattedCoverLetter = formatText(coverLettertext);

    let skillsText = fields && fields.skills ? fields.skills : 'N/A';
    let skillsTextFormatted = formatText(skillsText);

    // let fundingText = fields && fields.fundingRequest ? fields.fundingRequest : 'N/A';
    // let fundingTextFormatted = formatText(fundingText);

    let fundingStatus = fields && fields.fundingRequest
        ? (fields.fundingRequest === "1" ? "Funding is required" : "Funding is not required")
        : "No fields object or funding request field";

    // Styles:
    const styles = {
        display: 'inline-block',
        maxWidth: '100px',
        fontWeight: 700,
        height: '40px',
        fontSize: '12pt',
        lineHeight: 1.2,
    };
    let displayStyle = { display: styles.display };
    return (
        <div className="app-admin-wrap layout-sidebar-large">
            <DashboardHeader />
            <AdminNav />
            <div className="main-content-wrap d-flex flex-column sidenav-open">
                {
                    loading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-bubble spinner-bubble-primary m-5"></div>
                        </div>

                    ) : (
                        <div className="mb-4">
                            <h1>{message}</h1>
                            <SimpleCard title={`EVALUATION`} className="mb-4">
                            <Row className="justify-content-center">
                                <Col lg={6} md={6} sm={12} xs={12}>
                                {/* Input fields for evaluation scores */}
                                <div className="row justify-content-between mb-1">
                                <h5  className="text-capitalize mb-1 col-12 text-end" >
                                  {username}
                                </h5>
                            
                                </div>

                                <div className="row justify-content-between mb-2">
                                    <h5 style={displayStyle} className="text-capitalize mb-1 col-6">
                                    {isNewCampaign ? "Program Clarity" : "Creativity Score"}:
                                    </h5>
                                    <input
                                    style={styles}
                                    type="number"
                                    name="creativity"
                                    value={data.creativity || 0}
                                    onChange={handleInputChange}
                                    className="form-control col-6"
                                    min="0"
                                    max="5"
                                    />
                                </div>


                                <div className="row justify-content-between mb-2">
                                    <h5 style={displayStyle} className="text-capitalize mb-1 col-6">
                                    {isNewCampaign ? "Leadership Potential" : "Expression Score"}:
                                    </h5>
                                    <input
                                    style={styles}
                                    type="number"
                                    name="expression"
                                    value={data.expression || 0}
                                    onChange={handleInputChange}
                                    className="form-control col-6"
                                    min="0"
                                    max="5"
                                    />
                                </div>

                                <div className="row justify-content-between mb-2">
                                    <h5 style={displayStyle} className="text-capitalize mb-1 col-6">
                                    {isNewCampaign ? "Expression" : "Past Ambition"}:
                                    </h5>
                                    <input
                                    style={styles}
                                    type="number"
                                    name="past_ambition"
                                    value={data.past_ambition || 0}
                                    onChange={handleInputChange}
                                    className="form-control col-6"
                                    min="0"
                                    max="5"
                                    />
                                </div>

                                <div className="row justify-content-between mb-2">
                                    <h5 style={displayStyle} className="text-capitalize mb-1 col-6">
                                    {isNewCampaign ? "The X Factor" : "Future Ambition"}:
                                    </h5>
                                    <input
                                    style={styles}
                                    type="number"
                                    name="future_ambition"
                                    value={data.future_ambition || 0}
                                    onChange={handleInputChange}
                                    className="form-control col-6"
                                    min="0"
                                    max="5"
                                    />
                                </div>

                                <div className="row justify-content-between mb-2">
                                    <h5 style={displayStyle} className="text-capitalize mb-1 col-6">
                                    {isNewCampaign ? "Incubation Mindset" : "Relevance"}:
                                    </h5>
                                    <input
                                    style={styles}
                                    type="number"
                                    name="relevance"
                                    value={data.relevance || 0}
                                    onChange={handleInputChange}
                                    className="form-control col-6"
                                    min="0"
                                    max="5"
                                    />
                                </div>

                                {isNewCampaign && (
                                <div className="row justify-content-between mb-2">
                                    <h5 style={displayStyle} className="text-capitalize mb-1 col-6">
                                    Program Fit:
                                    </h5>
                                    <input
                                    style={styles}
                                    type="number"
                                    name="program_fit"
                                    value={data.program_fit || 0}
                                    onChange={handleInputChange}
                                    className="form-control col-6"
                                    min="0"
                                    max="5"
                                    />
                                </div>
                                )}

                                <div className="row justify-content-between mb-4">
                                    <h5 style={displayStyle} className="text-capitalize mb-1 col-6">
                                    Total Score:
                                    </h5>
                                    <input
                                    style={styles}
                                    type="number"
                                    value={data.totalScore}
                                    className="form-control col-6"
                                    disabled
                                    />
                                </div>
                                
                                                  <div className="row mb-2">
                    <h5  style={{ ...displayStyle, paddingBottom: "10px" }} className="text-capitalize mb-1 col-12" >
                      Remarks
                    </h5>

                    <div className="col-12">
                      <textarea
                        // style={styles}
                        name="remarks"
                        value={data.remarks || ""}
                        onChange={(e) =>
                          setData({ ...data, remarks: e.target.value })
                        }
                        className="form-control"
                        rows={3}
                      />
                    </div>
                  </div>
                                {/* Radio buttons for Evaluation Decision */}
                                <div className="row mb-4 align-items-center">
                                <h5
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    marginBottom: '0',
                                  }}
                                  className="text-capitalize mb-1 col-6"
                                >
                                  Application Status:
                                </h5>
                                <div className="col-6 d-flex flex-column align-items-start" style={{ paddingLeft: '276px', paddingTop: '16px' }}>
                                  {/* Recommended Radio Button */}
                                  <label className="form-check-label mb-2" style={{paddingRight:"16px"}}>
                                    <input
                                      type="radio"
                                      name="next_stage"
                                      value="recommended"
                                      checked={data.next_stage === true}
                                      onChange={(e) => handleInputChange(e, "recommended")}
                                      className="form-check-input"
                                      style={{
                                        width: '20px',
                                        height: '20px',
                                        marginRight: '10px',
                                        cursor: 'pointer',
                                      }}
                                    />
                                    Recommended
                                  </label>

                                  {/* Rejected Radio Button */}
                                  <label className="form-check-label mb-2" style={{paddingRight:"20px"}}>
                                    <input
                                      type="radio"
                                      name="next_stage"
                                      value="rejected"
                                      checked={data.next_stage === false}
                                      onChange={(e) => handleInputChange(e, "rejected")}
                                      className="form-check-input"
                                      style={{
                                        width: '20px',
                                        height: '20px',
                                        marginRight: '10px',
                                        cursor: 'pointer',
                                      }}
                                    />
                                    Rejected
                                  </label>

                                  {/* Waitlist Radio Button */}
                                  <label className="form-check-label" style={{paddingRight:"20px"}}>
                                    <input
                                      type="radio"
                                      name="next_stage"
                                      value="waitlist"
                                      checked={data.next_stage === null}
                                      onChange={(e) => handleInputChange(e, "waitlist")}
                                      className="form-check-input"
                                      style={{
                                        width: '20px',
                                        height: '20px',
                                        marginRight: '10px',
                                        cursor: 'pointer',
                                      }}
                                    />
                                    Waitlist
                                  </label>
                                </div>
                              </div>


                                {/* Buttons for actions */}
                                <div className="text-center">
                                    {/* <button
                                    style={styles}
                                    type="button"
                                    className="m-1 text-capitalize btn btn-success text-white"
                                    onClick={handleButtonClick1}
                                    >
                                    Select
                                    </button> */}
                                    <button
                                    style={styles}
                                    type="button"
                                    className="m-1 text-capitalize btn btn-outline-primary"
                                    onClick={handleButtonClick1}
                                    disabled={data.next_stage === undefined} // Disable button if no selection made
                                    >
                                    Save
                                    
                                    </button>
                                    {/* <button
                                    style={styles}
                                    type="button"
                                    className="m-1 text-capitalize btn btn-danger text-white"
                                    onClick={handleButtonClick1}
                                    >
                                    Reject
                                    </button> */}
                                </div>
                                </Col>
                                {otherevaluations.map((evaluation, index) => (
                                  <Col 
  lg={2} 
  md={3} 
  sm={3} 
  xs={12} 
  key={index} 
  style={{ paddingLeft: "55px" }}
>          {/* Admin Username */}
          <div className="text-right font-weight-bold mb-2">
            <h5>
           {evaluation.users_permissions_user?.data?.attributes?.username || "Unknown Admin"} 
           </h5>
          </div>

          {/* Input fields for evaluation scores */}
                                <div className="row justify-content-end mb-2">
                                 
                                    <input
                                    style={styles}
                                    type="number"
                                    name="creativity"
                                    value={evaluation.creativity || 0}
                                    className="form-control col-6"
                                    min="0"
                                    max="5"
                                    disabled
                                    />
                                </div>
        
                             <div className="row justify-content-end mb-2">
                                 
                                 <input
                                 style={styles}
                                 type="number"
                                 name="expression"
                                 value={evaluation.expression || 0}
                                 className="form-control col-6"
                                 min="0"
                                 max="5"
                                 disabled
                                 />
                             </div>
        
                           <div className="row justify-content-end mb-2">
                                 
                                 <input
                                 style={styles}
                                 type="number"
                                 name="past_ambition"
                                 value={evaluation.past_ambition || 0}
                                 className="form-control col-6"
                                 min="0"
                                 max="5"
                                 disabled
                                 />
                             </div>
        
                             <div className="row justify-content-end mb-2">
                                 
                                 <input
                                 style={styles}
                                 type="number"
                                 name="future_ambition"
                                 value={evaluation.future_ambition || 0}
                                 className="form-control col-6"
                                 min="0"
                                 max="5"
                                 disabled
                                 />
                             </div>
          <div className="row justify-content-end mb-2">
            <input
            style={styles}
              type="number"
              name="relevance"
              value={evaluation.relevance || 0}
              className="form-control col-6"
              min="0"
              max="5"
              disabled
            />
          </div>
          {isNewCampaign && (
          <div className="row justify-content-end mb-2">
            <input
            style={styles}
              type="number"
              name="program_fit"
              value={evaluation.program_fit || 0}
              className="form-control col-6"
              min="0"
              max="5"
              disabled
            />
          </div>
          )}
          <div className="row justify-content-end mb-4">
            <input
             style={styles}
              type="number"
              value={evaluation.totalScore || 0}
              className="form-control col-6"
              disabled
            />
          </div>

          {/* Evaluation Decision Label */}
          <div className="row justify-content-end align-items-center mb-4">
            <div className="col-6 d-flex align-items-center justify-content-end">

              <span
                style={{
                  color: evaluation.next_stage === true ? "#28a745" : evaluation.next_stage === null ? "#ffc107" : "#dc3545",
                  fontWeight: "bold",
                }}
              >
                {evaluation.next_stage === true ? "Recommended" : evaluation.next_stage === null ? "Waitlist" : "Rejected"}
              </span>
            </div>
          </div>
        </Col>
      ))}
                            </Row>
                            </SimpleCard>
                            <Row>
                                <Col lg={12} md={12} sm={12} xs={12}>

                                    <SimpleCard title={`${fields && fields.first_name ? fields.first_name : 'N/A'}`}>

                                        <Tabs defaultActiveKey="home" id="home">
                                            <Tab eventKey="home" title="BASIC INFORMATION">
                                                <div className="row">
                                                    {/* Name */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Name:</strong> {fields && fields.first_name ? fields?.first_name : 'N/A'}</p>
                                                    {/* Middle Name - HIDDEN */}
                                                    {/* <p style={{fontSize:"19px"}} className='col-6'><strong>Middle Name:</strong> {fields && fields.middle_name ? fields?.middle_name : 'N/A'}</p> */}
                                                    {/* Last Name */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Last Name:</strong> {fields && fields.last_name ? fields?.last_name : 'N/A'}</p>
                                                    {/* Primary Email */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Primary Email:</strong> {fields && fields.primary_email ? fields?.primary_email : 'N/A'}</p>
                                                    {/* Secondary Email - HIDDEN */}
                                                    {/* <p style={{fontSize:"19px"}} className='col-6'><strong>Secondary Email:</strong> {fields && fields.secondary_email ? fields?.secondary_email : 'N/A'}</p> */}
                                                    {/* Primary Contact */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Primary Contact:</strong> {fields && fields.primary_phone_number ? fields.primary_phone_number : 'N/A'}</p>
                                                    {/* Secondary Contact */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Secondary Contact:</strong> {fields && fields.secondary_phone_number ? fields.secondary_phone_number : 'N/A'}</p>
                                                    {/* Landline - HIDDEN */}
                                                    {/* <p style={{fontSize:"19px"}} className='col-6'><strong>Landline:</strong> {fields && fields.landline ? fields.landline : 'N/A'}</p> */}
                                                    {/* Gender */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Gender:</strong> {fields && fields.gender ? fields.gender : 'N/A'}</p>
                                                    {/* Date of Birth */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Date of Birth:</strong> {fields && fields.date_of_birth ? fields.date_of_birth : 'N/A'}</p>
                                                    {/* Age */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Age:</strong> {
                                                      fields && fields.date_of_birth
                                                        ? (() => {
                                                            const birthDate = new Date(fields.date_of_birth);
                                                            const today = new Date();
                                                            let age = today.getFullYear() - birthDate.getFullYear();
                                                            const monthDiff = today.getMonth() - birthDate.getMonth();
                                                            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) { age--; }
                                                            return age;
                                                          })()
                                                        : 'N/A'
                                                    }</p>
                                                    {/* Nationality */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Nationality:</strong> {fields && fields.nationality ? fields.nationality : 'N/A'}</p>
                                                    {/* Province */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Province:</strong> {fields && fields.province ? fields.province : 'N/A'}</p>
                                                    {/* Address - HIDDEN */}
                                                    {/* <p style={{fontSize:"19px"}} className='col-6'><strong>Address:</strong> {fields && fields.address ? fields.address : 'N/A'}</p> */}
                                                    {/* City */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>City:</strong> {fields && fields.city ? fields.city : 'N/A'}</p>
                                                    {/* Disability */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Disability:</strong> {fields && fields.disability ? fields.disability : 'N/A'}</p>
                                                    {/* Disability Reason */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>Disability Reason:</strong> {fields && fields.reason ? fields.reason : 'N/A'}</p>
                                                    {/* LinkedIn - text only, no button */}
                                                    <p style={{fontSize:"19px"}} className='col-6'><strong>LinkedIn:</strong> {fields && fields.linkedin_url ? fields.linkedin_url : 'N/A'}</p>
                                                </div>
                                            </Tab>
                                            <Tab eventKey="academic" title="ACADEMIC">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{fontSize:"19px"}} scope="col">Institute</th>
                                                            <th style={{fontSize:"19px"}} scope="col">Degree</th>
                                                            <th style={{fontSize:"19px"}} scope="col">Field Of Study</th>
                                                            <th style={{fontSize:"19px"}} scope="col">Start Year </th>
                                                            <th style={{fontSize:"19px"}} scope="col">End Year </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {education && education?.map((edu, index) => (
                                                            <tr key={index}>
                                                                <th style={{fontSize:"19px"}} scope="row">{edu?.attributes.institute || 'N/A'}</th>
                                                                <td style={{fontSize:"19px"}}>{edu?.attributes.degree || 'N/A'}</td>
                                                                <td style={{fontSize:"19px"}}>{edu?.attributes.field_of_study || 'N/A'}</td>
                                                                <td style={{fontSize:"19px"}}>{edu?.attributes.start_year || 'N/A'}</td>
                                                                <td style={{fontSize:"19px"}}>{edu?.attributes.end_year || 'N/A'}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </Tab>
                                            <Tab eventKey="profile" title="PROFESSIONAL">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{fontSize:"19px"}} scope="col">Organization</th>
                                                            <th style={{fontSize:"19px"}} scope="col">Job</th>
                                                            <th style={{fontSize:"19px"}} scope="col">Type Of Job</th>

                                                            <th style={{fontSize:"19px"}} scope="col">Start Year </th>
                                                            <th style={{fontSize:"19px"}} scope="col">End Year </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {employment && employment.map((employ, index) => (
                                                            <tr key={index}>
                                                                <th style={{fontSize:"19px"}} scope="row">{employ?.attributes.organization_name || 'N/A'}</th>
                                                                <td style={{fontSize:"19px"}}>{employ?.attributes.job_title || 'N/A'}</td>
                                                                <td style={{fontSize:"19px"}}>{employ?.attributes.type_of_job || 'N/A'}</td>

                                                                <td style={{fontSize:"19px"}}>{employ?.attributes.start_year || 'N/A'}</td>
                                                                <td style={{fontSize:"19px"}}>{employ?.attributes.end_year || 'N/A'}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </Tab>
                                            <Tab eventKey="resume" title="RESUME">
                                                <p style={{fontSize:"19px"}}><strong>Resume:</strong> <br />{resume && resume?.url ? 'Resume Attached' : 'N/A'}</p>

                                                <div style={{fontSize:"19px"}}>
                                                    {resume?.url && <button type="button" className="btn btn-outline-primary m-1" onClick={() => window.open(`${resume?.url}`, '_blank')}>View</button>}
                                                </div>
                                            </Tab>
                                        <Tab eventKey="contact" title="PERSONAL STATEMENT">
  <PersonalStatementTab
    personalstatement={personalstatement}
    campaigin_id={campaigin_id}
    applicationId={personalStatementId}
  />
</Tab>
                                            <Tab eventKey="reference" title="REFERENCE LETTER">
                                            <p style={{fontSize:"19px"}}><strong>Name:</strong> <br />{referenceletterdata && referenceletterdata?.name ? referenceletterdata?.name : 'N/A'}</p>
                                            <p style={{fontSize:"19px"}}><strong>Organization Name:</strong> <br />{referenceletterdata && referenceletterdata?.organization_name ? referenceletterdata?.organization_name : 'N/A'}</p>
                                            <p style={{fontSize:"19px"}}><strong>Designation:</strong> <br />{referenceletterdata && referenceletterdata?.designation ? referenceletterdata?.designation : 'N/A'}</p>
                                            <p style={{fontSize:"19px"}}><strong>Contact Number:</strong> <br />{referenceletterdata && referenceletterdata?.contact_number ? referenceletterdata?.contact_number : 'N/A'}</p>
                                            <p style={{fontSize:"19px"}}><strong>Email:</strong> <br />{referenceletterdata && referenceletterdata?.email ? referenceletterdata?.email : 'N/A'}</p>

                                                <p style={{fontSize:"19px"}}><strong>Reference:</strong> <br />{referenceletter && referenceletter?.url ? 'Reference Letter Attached' : 'N/A'}</p>

                                                <div>
                                                    {referenceletter?.url && <button type="button" className="btn btn-outline-primary m-1" onClick={() => window.open(`${referenceletter?.url}`, '_blank')}>View</button>}
                                                </div>
                                            </Tab>
                                            <Tab eventKey="funding" title="FUNDING">
                                                <strong style={{fontSize:"19px"}} className='mb-3'>Funding Request: </strong>
                                                <p style={{fontSize:"19px"}}>
                                                {referenceletterdata?.scholarship
                                                  ? "Applying for Scholarship"
                                                  : "Not Applying for Scholarship"}
                                              </p>
                                              
                                             

                                            </Tab>
                                            {/* <Tab eventKey="Scores" title="APTITUDE TEST SCORE">
                                                <strong style={{fontSize:"19px"}} className='mb-3'>Aptitude Test Scores:</strong>
                                                <p style={{fontSize:"19px"}}><strong>Quantitative Reasoning:</strong> {score?.quantitative_reasoning} / 5</p>
                                                <p style={{fontSize:"19px"}}><strong>Verbal Reasoning:</strong> {score?.verbal_reasoning} / 5</p>
                                                <p style={{fontSize:"19px"}}><strong>Energy & Climate Trivia:</strong> {score?.energy_climate_trivia} / 5</p>

                                                <hr />
                                                <p style={{fontSize:"19px"}}><strong>Total Score:</strong> {score?.total} / 15</p>

                                            </Tab> */}
                                        </Tabs>
                                    </SimpleCard>
                                </Col>
                            </Row>
                        </div>
                    )}
            </div>
        </div>
    );
};

export default ViewApplication;
